module.exports = __webpack_public_path__ + "img/horizontal_7_2_pp2_7005.6f23cbb9.png";